<template>
    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="40%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">MARS - {{getTitle}}: {{ right.name }}</span>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-container grid-list-xs style="overflow-y: auto; margin-top: -20px">
                        <v-layout wrap>
                            <v-flex class="modal-flex-height" xs12 sm5>
                                <v-subheader>Name</v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                <v-text-field
                                        id="modify_right_name_field"
                                        v-model="right.name"
                                        name="name"
                                        color="grey darken-2"
                                        :disabled="disabled"
                                        class="text-xs-left"
                                        v-validate="'required:true'"
                                        :error-messages="errors.first('name')"
                                ></v-text-field>
                            </v-flex>


                            <v-flex class="modal-flex-height" xs12 sm5>
                                <v-subheader>Description</v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                <v-text-field
                                        id="modify_right_description_field"
                                        v-model="right.description"
                                        name="description"
                                        color="grey darken-2"
                                        :disabled="disabled"
                                        class="text-xs-left"
                                ></v-text-field>
                            </v-flex>

                        </v-layout>
                    </v-container>

                    <v-alert :value="error" type="error" transition="scale-transition">
                        {{ errorMessage }}
                    </v-alert>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="modify_right_save_button" class="text-none" color="green" small dark @click="onSaveRight"
                               :disabled="disabled">
                            Save
                        </v-btn>
                        <v-btn id="modify_right_cancel_button" class="text-none" small @click="close">Cancel</v-btn>
                    </v-card-actions>

                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>
</template>

<script>

    import rightinterface from "../../../../interfaces/rightinterface";
    import {EventBus} from "../../../../eventbus";
    import errormessagemanager from "../../../../managers/errormessagemanager";

    export default {
        name: 'ShowRightModal',

        props: {
            value: Boolean,

            editMode: Boolean,
            disabled: Boolean,
            isAppRight: Boolean,

            right: {
                rightId: Number,
                name: String,
                description: String
            }
        },

        data: () => ({
            error: false,
            errorMessage: null
        }),

        computed: {
            getTitle: function () {
                let title = this.editMode ? "Edit" : "Create";
                title += this.isAppRight ? " app right" : " pool group right";
                return title;
            },

            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {

            async onSaveRight() {
                this.clearAlert();

                this.$validator.validateAll().then(async result => {
                    if (result) {
                        let response = null;

                        if (!this.editMode) {
                            if (this.isAppRight) {
                                await rightinterface.postAppRight(this.right, res => {
                                    response = res;
                                });
                            } else {
                                await rightinterface.postPoolGroupRight(this.right, res => {
                                    response = res;
                                });
                            }
                        } else {
                            if (this.isAppRight) {
                                await rightinterface.putAppRight(this.right, res => {
                                    response = res;
                                });
                            } else {
                                await rightinterface.putPoolGroupRight(this.right, res => {
                                    response = res;
                                })
                            }
                        }

                        if (response != null && response.error) {
                            if (!this.editMode) {
                                errormessagemanager.getInsertErrorMessage(response.status, message => {
                                    this.errorMessage = message;
                                });
                                this.error = response.error;
                            } else {
                                errormessagemanager.getUpdateErrorMessage(response.status, message => {
                                    this.errorMessage = message;
                                });
                                this.error = response.error;
                            }
                        } else if (!this.error) {
                            await EventBus.$emit('onRefreshRightList');
                            await this.close();
                        }
                    }
                })
            },

            async close() {
                await EventBus.$emit('rightModalClosed');

                this.clearData();
                this.clearAlert();

                this.onShow = false;
            },

            clearData() {
                this.right.rightId = null;
                this.right.name = null;
                this.right.description = null;

                this.$validator.errors.clear();
                this.$validator.fields.items.forEach(field => field.reset());
                this.$validator.fields.items.forEach(field => this.errors.remove(field));
                this.$validator.resume();
            },

            clearAlert() {
                this.error = false;
                this.errorMessage = null;
            }
        }
    }


</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/common/rights/modals/ShowRightModal.vue